import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionOurProducts from '@/section-our-products'
import SectionVoting from '@/section-voting'
import SectionRating from '@/section-rating'
import SectionCasting from '@/section-casting'
import SectionRevenue from '@/section-revenue'
import SectionMeaningful from '@/section-meaningful'
import SectionIntegration from '@/section-integration'

import shareImg from './images/our_products.png'

class OurProducts extends Component {
  render() {
    const { data } = this.props

    return (
      <div>
        <Helmet>
          <title>Our products</title>
          <meta property="og:title" content="Our products" />
          <meta property="og:description" content="Grow your audience and revenue. Share content to beauty fans across the globe. We have developed the most advanced digital tools for you in close cooperation with beauty pageants for the past 4 years." />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/our_products/" />
          <meta property="og:image:alt" content="Our products - Next Miss" />
        </Helmet>
        <SectionOurProducts />
        <SectionVoting data={data} gray />
        <SectionRating data={data} />
        <SectionCasting data={data} gray />
        <SectionRevenue data={data} />
        <SectionMeaningful data={data} gray />
        <SectionIntegration />
      </div>
    )
  }
}

export default OurProducts

export const query = graphql`
  query PlatformQuery {
    # Voting
    votingImg1: imageSharp(id: { regex: "/voting1/" }) {
      sizes(maxWidth: 176) {
        ...GatsbyImageSharpSizes
      }
    }
    votingImg2: imageSharp(id: { regex: "/voting2/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    }
    votingImg3: imageSharp(id: { regex: "/voting3/" }) {
      sizes(maxWidth: 176) {
        ...GatsbyImageSharpSizes
      }
    }
    # Rating
    ratingImg1: imageSharp(id: { regex: "/rating1/" }) {
      sizes(maxWidth: 318) {
        ...GatsbyImageSharpSizes
      }
    }
    ratingImg2: imageSharp(id: { regex: "/rating2/" }) {
      sizes(maxWidth: 196) {
        ...GatsbyImageSharpSizes
      }
    }
    ratingImg3: imageSharp(id: { regex: "/rating3/" }) {
      sizes(maxWidth: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    ratingImg4: imageSharp(id: { regex: "/rating4/" }) {
      sizes(maxWidth: 158) {
        ...GatsbyImageSharpSizes
      }
    }
    # Casting
    castingImg1: imageSharp(id: { regex: "/casting1/" }) {
      sizes(maxWidth: 184) {
        ...GatsbyImageSharpSizes
      }
    }
    castingImg2: imageSharp(id: { regex: "/casting2/" }) {
      sizes(maxWidth: 490) {
        ...GatsbyImageSharpSizes
      }
    }
    castingImg3: imageSharp(id: { regex: "/casting3/" }) {
      sizes(maxWidth: 184) {
        ...GatsbyImageSharpSizes
      }
    }
    # Revenue
    revenueImg1: imageSharp(id: { regex: "/revenue1/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    }
    revenueImg2: imageSharp(id: { regex: "/revenue2/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    }
    revenueImg3: imageSharp(id: { regex: "/revenue3/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    }
    revenueImg4: imageSharp(id: { regex: "/revenue4/" }) {
      sizes(maxWidth: 186) {
        ...GatsbyImageSharpSizes
      }
    }
    # Meaningful
    meaningfulImg1: imageSharp(id: { regex: "/meaningful1/" }) {
      sizes(maxWidth: 368) {
        ...GatsbyImageSharpSizes
      }
    }
    meaningfulImg2: imageSharp(id: { regex: "/meaningful2/" }) {
      sizes(maxWidth: 508) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/our_products.js